export default function Linear_Regression() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Linear_Regression</h1>
      <p>Content for Linear_Regression goes here.</p>
    </div>
  );
}